import React, { useCallback, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './Start.css';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

function ROI() {
    const navigate = useNavigate();
    const [monthlyTasks, setMonthlyTasks] = useState('');
    const [workHours, setWorkHours] = useState('');
    const [salaryPerHour, setSalaryPerHour] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);

    const token = localStorage.getItem('access_token');

    useEffect(() => {
        if (!token) {
            navigate('/');
        }
    }, [token, navigate]);

    const handleSubmit = () => {
        const errors = [];
        if (!monthlyTasks) errors.push('1ヶ月の業務件数を入力してください');
        if (!workHours) errors.push('1件あたり労働時間を入力してください');
        if (!salaryPerHour) errors.push('時給を入力してください');
        setErrorMessages(errors);

        
        if (errors.length === 0) {
          setIsProcessing(true);
          setTimeout(() => {
              navigate('/result', {
                  state: {
                      monthlyTasks,
                      workHours,
                      salaryPerHour
                  }
              });
              setIsProcessing(false);
          }, 2500);
      }
    };

    const particlesInit = useCallback(async (engine) => {
        await loadSlim(engine); // ✅ 让粒子引擎工作！
      }, []);

    if (isProcessing) {
        return (
          <div style={{ position: "relative", width: "100vw", height: "100vh", background: "#f8fbff", overflow: "hidden" }}>
      <Particles
        init={particlesInit}
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 1 }}
        options={{
          fullScreen: { enable: false },
          background: { color: { value: "transparent" } },
          particles: {
            number: { value: 60 },
            color: { value: "#0f62fe" },
            shape: { type: "circle" },
            opacity: { value: 0.6 },
            size: { value: 3 },
            links: {
              enable: true,
              distance: 120,
              color: "#0f62fe",
              opacity: 0.5,
              width: 1,
            },
            move: {
              enable: true,
              speed: 1,
              outModes: { default: "bounce" },
            },
          },
          detectRetina: true,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "#0f62fe",
          fontSize: "1.5rem",
          fontWeight: "500",
        }}
      >
        <div
          style={{
            width: "60px",
            height: "60px",
            border: "5px solid #cce4ff",
            borderTop: "5px solid #0f62fe",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            marginBottom: "20px",
          }}
        />
        <p className="typewriter">AIが診断結果を分析中...</p>
      </div>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
        );
      }
      

    return (
        <div className="app-container">
            <Helmet>
                <link
                    href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&display=swap"
                    rel="stylesheet"
                />
            </Helmet>
            <header className="header">
                <div className="logo">
                    <h1></h1>
                    <p className="subtitle" style={{ marginBottom: '10px' }}></p>
                </div>
            </header>
            <main className="main-content">
                <section id="business-info-screen" className="screen active">
                    <div className="card" style={{ marginTop: '100px' }}>
                        <h2 className="section-title">業務情報入力</h2>
                        <p className="info-text">より正確なROI計算のために、以下の情報を入力してください。</p>
                        {errorMessages.length > 0 && (
                            <div className="error-container">
                                {errorMessages.map((msg, index) => (
                                    <p key={index} className="error">{msg}</p>
                                ))}
                            </div>
                        )}
                        <div className="form-container">
                            <div className="form-group">
                                <label htmlFor="monthly-tasks">1ヶ月の業務件数</label>
                                <input
                                    type="number"
                                    id="monthly-tasks"
                                    className="form-input"
                                    placeholder="例: 500"
                                    min="1"
                                    value={monthlyTasks}
                                    onChange={(e) => setMonthlyTasks(e.target.value)}
                                />
                                <span className="unit">件</span>
                            </div>
                            <div className="form-group">
                                <label htmlFor="work-hours">1件あたり作業時間</label>
                                <input
                                    type="number"
                                    id="work-hours"
                                    className="form-input"
                                    placeholder="例: 20"
                                    min="1"
                                    value={workHours}
                                    onChange={(e) => setWorkHours(e.target.value)}
                                />
                                <span className="unit">分</span>
                            </div>
                            <div className="form-group">
                                <label htmlFor="salary-per-hour">平均時間単価</label>
                                <input
                                    type="number"
                                    id="salary-per-hour"
                                    className="form-input"
                                    placeholder="例: 1500"
                                    min="1000"
                                    value={salaryPerHour}
                                    onChange={(e) => setSalaryPerHour(e.target.value)}
                                />
                                <span className="unit">円</span>
                            </div>
                        </div>
                        <div className="button-container">
                            <button id="business-info-back-button" className="btn btn-secondary">前へ</button>
                            <button
                                id="calculate-button"
                                className="btn btn-primary"
                                onClick={handleSubmit}
                            >
                                結果を計算する
                            </button>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}

export default ROI;
